export default "__VITE_PUBLIC_ASSET__bd239a68__"